import { defineComponent, nextTick, onBeforeUnmount, onMounted, ref } from 'vue'

import PointPage from '@/organizations/_default/point'
import ProductModal from '@/organizations/mitsubishi-food/default/components/ProductModal.vue'
import FilterInfo from '@/organizations/mitsubishi-food/default/components/FilterInfo.vue'
import { Filters } from '@/services/Filters.ts'

export default defineComponent({
  extends: PointPage,
  components: {
    ProductModal,
    FilterInfo
  },
  setup(props, context) {
    const page = PointPage.setup(props, context)

    /**
     * クリックしたフィルターを保持
     *
     * 商品モーダルに以下のプロパティを使用
     * filter.name: 商品名(既存)
     * filter.image.url: 商品画像のURL(既存)
     * filter.extra_fields.product_description: 商品説明(追加)
     * filter.link.url: 商品詳細ページのURL(既存)
     * filter.extra_fields.product_features: 商品特徴(追加)
     */
    const selectedProduct = ref({})
    const productModalRef = ref(null)
    let filtersElement = null

    /**
     * 商品検索条件を商品モーダルに表示する
     *
     * @param {Object} searchCondition 商品検索条件
     */
    const openProductModal = (searchCondition) => {
      selectedProduct.value = searchCondition
      nextTick(() => {
        productModalRef.value?.open()
      })
    }

    /**
     * 商品リンククリック時に外部ページへ遷移せず商品モーダルを表示する
     *
     * @param {MouseEvent} event クリックイベント
     */
    const onProductFilterLinkClicked = (event) => {
      const target = event.target
      const link = target instanceof globalThis.Element
        ? target.closest('.filter-search-condition.link')
        : null

      if (!link || !filtersElement?.contains(link)) {
        return
      }

      event.preventDefault()

      const filterId = link.dataset.id?.replace(/^search-condition-/, '')
      if (!filterId) {
        return
      }

      const searchCondition = Filters.findById(Filters.TYPE_SEARCH_CONDITIONS, filterId)
      if (!searchCondition) {
        return
      }

      openProductModal(searchCondition)
    }

    onMounted(() => {
      nextTick(() => {
        filtersElement = globalThis.document?.querySelector('#PointContents #Filters')
        filtersElement?.addEventListener('click', onProductFilterLinkClicked)
      })
    })

    onBeforeUnmount(() => {
      filtersElement?.removeEventListener('click', onProductFilterLinkClicked)
    })

    return {
      ...page,
      selectedProduct,
      productModalRef,
    }
  }
})
